module.exports = __webpack_public_path__ + "img/25.32c7c018.png";